{
  "SEARCH": {
    "TABS": {
      "ALL": "Toate",
      "CONTACTS": "Contacte",
      "CONVERSATIONS": "Conversații",
      "MESSAGES": "Mesaje"
    },
    "SECTION": {
      "CONTACTS": "Contacte",
      "CONVERSATIONS": "Conversații",
      "MESSAGES": "Mesaje"
    },
    "VIEW_MORE": "View more",
    "LOAD_MORE": "Load more",
    "SEARCHING_DATA": "In căutare",
    "LOADING_DATA": "Loading",
    "EMPTY_STATE": "Nu s-a găsit niciun {item} pentru interogarea \"{query}\"",
    "EMPTY_STATE_FULL": "Nu s-au găsit rezultate pentru interogarea \"{query}\"",
    "PLACEHOLDER_KEYBINDING": "/ să se concentreze",
    "INPUT_PLACEHOLDER": "Tastați 3 sau mai multe caractere de căutat",
    "RECENT_MESSAGES": "Mesajele mele trimise recent",
    "EMPTY_STATE_DEFAULT": "Căutați după id-ul conversației, e-mail, numărul de telefon, mesajele pentru rezultate de căutare mai bune. ",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Citeşte mai mult",
    "WROTE": "scrisese:",
    "FROM": "de la",
    "EMAIL": "e-mail",
    "EMAIL_SUBJECT": "subiect"
  }
}
